(function () {
  function asBoolean(value, fallback) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return fallback;
  }

  function initReviewSlider(section) {
    if (!section || section.dataset.reviewSliderReady === 'true') return;

    var track = section.querySelector('[data-review-slider-track]');
    var nextBtn = section.querySelector('.carousel-arrow[id^="arrow-next-"]');
    var prevBtn = section.querySelector('.carousel-arrow[id^="arrow-prev-"]');
    var dotsEl = section.querySelector('[data-review-slider-dots]');

    if (!track) return;

    var originalCards = Array.prototype.slice.call(track.children);
    var total = originalCards.length;

    if (!total) return;

    section.dataset.reviewSliderReady = 'true';

    var index = 0;
    var autoplayTimer = null;
    var touchStartX = 0;
    var touchEndX = 0;
    var gap = 16;
    var autoplayEnabled = asBoolean(section.dataset.autoplay, true);
    var autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 3000;
    var loopEnabled = asBoolean(section.dataset.loop, false);
    var infiniteEnabled = asBoolean(section.dataset.infinite, true) && total > 1;

    function getGap() {
      var styles = window.getComputedStyle(track);
      var parsedGap = parseFloat(styles.columnGap || styles.gap);
      return Number.isNaN(parsedGap) ? gap : parsedGap;
    }

    function getStep() {
      return originalCards[0].getBoundingClientRect().width + getGap();
    }

    function updateDots() {
      if (!dotsEl) return;

      var dots = dotsEl.querySelectorAll('.carousel-dot');
      var realIndex = infiniteEnabled ? (index - total + total) % total : index;

      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('active', dotIndex === realIndex);
      });
    }

    function move(animate) {
      track.style.transition = animate ? 'transform 0.5s ease' : 'none';
      track.style.transform = 'translateX(' + (-index * getStep()) + 'px)';
      updateDots();
    }

    function setupInfinite() {
      if (!infiniteEnabled) return;

      originalCards.forEach(function (card) {
        track.appendChild(card.cloneNode(true));
      });

      originalCards.slice().reverse().forEach(function (card) {
        track.insertBefore(card.cloneNode(true), track.firstChild);
      });

      index = total;
      move(false);
    }

    function nextNormal() {
      if (index < total - 1) {
        index += 1;
      } else if (loopEnabled) {
        index = 0;
      } else {
        return;
      }

      move(true);
    }

    function prevNormal() {
      if (index > 0) {
        index -= 1;
      } else if (loopEnabled) {
        index = total - 1;
      } else {
        return;
      }

      move(true);
    }

    function nextInfinite() {
      index += 1;
      move(true);

      window.setTimeout(function () {
        if (index >= total * 2) {
          index = total;
          move(false);
        }
      }, 500);
    }

    function prevInfinite() {
      index -= 1;
      move(true);

      window.setTimeout(function () {
        if (index <= 0) {
          index = total;
          move(false);
        }
      }, 500);
    }

    function next() {
      if (infiniteEnabled) {
        nextInfinite();
      } else {
        nextNormal();
      }
    }

    function prev() {
      if (infiniteEnabled) {
        prevInfinite();
      } else {
        prevNormal();
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || total < 2) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = window.setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      window.clearInterval(autoplayTimer);
    }

    function buildDots() {
      if (!dotsEl) return;

      dotsEl.innerHTML = '';

      for (var i = 0; i < total; i += 1) {
        var dot = document.createElement('button');
        dot.className = 'carousel-dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));

        dot.addEventListener('click', (function (dotIndex) {
          return function () {
            index = infiniteEnabled ? total + dotIndex : dotIndex;
            move(true);
          };
        })(i));

        dotsEl.appendChild(dot);
      }
    }

    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });
    section.addEventListener('touchend', function (event) {
      touchEndX = event.changedTouches[0].screenX;

      if (touchStartX - touchEndX > 45) next();
      if (touchEndX - touchStartX > 45) prev();

      startAutoplay();
    }, { passive: true });

    window.addEventListener('resize', function () {
      move(false);
    });

    buildDots();
    setupInfinite();
    move(false);
    startAutoplay();
  }

  function initAllReviewSliders(root) {
    var scope = root || document;
    var sliders = [];

    if (scope.matches && scope.matches('[data-review-slider]')) {
      sliders.push(scope);
    }

    sliders = sliders.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-review-slider]')));

    sliders.forEach(function (slider) {
      initReviewSlider(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllReviewSliders(document);
    });
  } else {
    initAllReviewSliders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllReviewSliders(event.target);
  });
})();
